<ng-container *ngIf="(avatar$ | async) as avatar; else notAvatar">
<img
  loading="lazy"
  (error)="loadImageError($event)"
  [ngStyle]="{ 'background-color': color$ | async }"
  class="avatar-img invert"
  [src]="avatar"
/>
</ng-container>
<ng-template #notAvatar>
  <div class="avatar-icon text-white" [ngStyle]="{ 'background-color': color$ | async }">
    <div [ngSwitch]="type" class="d-flex w-100 h-100 align-items-center justify-content-center">
      <ng-template ngSwitchCase="private">
        <ngx-jazzicon diameter="63" [seed]="seed"></ngx-jazzicon>
        <!--<i-feather name="user" class="icon-md"></i-feather>-->
      </ng-template>
      <ng-template ngSwitchCase="ai_bot">
        <i-feather name="cpu" class="icon-md"></i-feather>
      </ng-template>
      <ng-template ngSwitchCase="bot">
        <i-feather name="cpu" class="icon-md"></i-feather>
      </ng-template>
      <ng-template ngSwitchCase="group">
        <i-feather name="users" class="icon-md"></i-feather>
      </ng-template>
      <ng-template ngSwitchCase="supergroup">
        <i-feather name="users" class="icon-md"></i-feather>
      </ng-template>
      <ng-template ngSwitchCase="channel">
        <i-feather name="tv" class="icon-md"></i-feather>
      </ng-template>
      <ng-template ngSwitchCase="self">
        <i-feather name="bookmark" class="icon-md"></i-feather>
      </ng-template>
      <ng-template ngSwitchCase="chat">
        <i-feather name="message-square" class="icon-md"></i-feather>
      </ng-template>
      <ng-template ngSwitchCase="plus">
        <i-feather name="plus-circle" class="icon-md"></i-feather>
      </ng-template>
      <ng-template ngSwitchCase="sender">
        <i-feather name="message-square" class="icon-md"></i-feather>
      </ng-template>
      <ng-template ngSwitchCase="partner">
        <i-feather name="dollar-sign" class="icon-md"></i-feather>
      </ng-template>
      <ng-template ngSwitchCase="support">
        <i-feather name="life-buoy" class="icon-md"></i-feather>
      </ng-template>
      <ng-template ngSwitchDefault>
        <i-feather name="image" class="icon-md"></i-feather>
      </ng-template>
    </div>
  </div>
</ng-template>
<ng-content></ng-content>

